module.exports = __webpack_public_path__ + "static/media/1_pl.922b12c2.png";